import * as React from "react";
import { I18n } from "react-redux-i18n";

import { getTestAttributes } from "@common/utils/tests";
import { Checkbox } from "@common/components/checkbox";
import { MODULE_NAME } from "@modules/invite-status/constants/shared";

import { InvitesExportOptionKeys } from "../invites-export.types";

import "./export-options.styles.scss";

export type InvitesExportOptionsProps = {
  onChange: (value: Array<InvitesExportOptionKeys>) => void;
  value: Array<InvitesExportOptionKeys>;
};

export const InvitesExportOptions: React.FC<InvitesExportOptionsProps> = ({ onChange, value }) => {
  const options = React.useMemo(() => {
    const config: Array<{ label: string; value: InvitesExportOptionKeys }> = [
      { label: "Include Column Headings", value: InvitesExportOptionKeys.showHeaders },
    ];

    return config;
  }, []);

  const handleOptionChange = React.useCallback(
    (checked: boolean, selectedOption: { value: InvitesExportOptionKeys }) => {
      if (checked) {
        onChange([...value, selectedOption.value]);
      } else {
        onChange(value.filter((option) => option !== selectedOption.value));
      }
    },
    [onChange, value]
  );

  return (
    <div className="InvitesExportOptions">
      <h6 className="InvitesExportSettings__title">{I18n.t("Options")}</h6>
      {options.map((option, optionIndex) => (
        <Checkbox
          {...getTestAttributes(MODULE_NAME, `invites-export-option-${optionIndex}`, "checkbox")}
          key={option.value}
          checked={value.includes(option.value)}
          onChange={(checked) => handleOptionChange(checked, option)}
          label={I18n.t(option.label)}
          classes={{
            label: "InvitesExportOptions__checkbox__label",
            input: "InvitesExportOptions__checkbox__input",
          }}
        />
      ))}
    </div>
  );
};
